<div class="row no-gutters" [ngClass]="{'mt-2': !first}" *ngFor="let note of notes; let first = first">
    <div class="col-auto text-left">
        <span class="ic-info-white mr-2"></span>
    </div>
    <div class="col-10 text-md-left">
        <div>{{note.note}}</div>

        <div class="font-weight-normal">
            <span>{{'CourtEventDetails.CreatedBy' | translate}} </span>{{note.createdBy.name}} &#64;
            {{note.createdAt | bcDateTime: 'MMM DD, YYYY'}}
        </div>
    </div>
</div>